<template>
    <div>
        <v-card>
            <v-card-title>フィードバック・追加コメント / Feedback and Additional Comments</v-card-title>
            <v-card flat v-for="(comment,index) in commentAtCreation" :key="index">
                <v-card-subtitle class="overline">
                    <!-- <div>{{formatDate(comment.time)}}</div> -->
                    <div>{{new Date(comment.time).toString()}}</div>
                    <div class="teal--text">{{comment.author}}: </div>
                </v-card-subtitle>
                <v-card-text class="font-weight-medium">{{comment.comment}}</v-card-text>
            </v-card>
            <v-divider></v-divider>
            <v-textarea
            class="mt-2 mx-2"
            label="Comment to Concierge"
            v-model="newComment"
            outlined
            flat
            ></v-textarea>
            <v-card-actions>
                <v-btn small text @click="sendNewComment()">send</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {db, auth} from '@/fb'

export default {
    name:'commentCard',
    props:['updateKey','ticketId'],
    data(){
        return{
            newComment:null,
            currentUser: auth.currentUser.email,

            commentAtCreation:[],

            completed_collec_id:null,

            ticket_details:null,
        }
    },
    methods:{
        formatDate(dateNow){
            let date = new Date(dateNow);
            return String(date.getFullYear())+'-'+String(date.getMonth()+1)+'-'+String(date.getDay())+' '+String(date.getHours())+':'+String(date.getMinutes())
        },
        sendNewComment(){
            let ref = db.collection('ticket_completed').doc(this.completed_collec_id).collection('comment')
            ref.add({
                author:this.currentUser,
                time:Date.now(),
                comment:this.newComment,
                person_in_charge:this.ticket_details.submitted_by,
                ticket_number:this.ticket_details.ticket_number,
                ticket_subject:this.ticket_details.ticket_subject
            })
            .then(()=>{
                this.$emit("send-new-comment",this.updateKey + 1);
            })
        }
    },
    created(){
        let ref_completed_id = db.collection('ticket_completed').where('ticket_number','==',this.ticketId)
        ref_completed_id.get().then(snap=>{
            snap.forEach(doc=>{
                this.completed_collec_id = doc.id
                this.ticket_details=doc.data()
                let ref_comment = db.collection('ticket_completed').doc(this.completed_collec_id).collection('comment').orderBy('time')
                ref_comment.get().then(snap=>{
                    snap.forEach(doc=>{
                        this.commentAtCreation.push(doc.data())
                    })
                })
            })
        })
        
    }
}
</script>